import { gql } from '@apollo/client';

export const REDEEM_REDEEMABLE_MUTATION = gql`
  mutation RedeemRedeemable($data: RedeemRedeemableInput!) {
    redeemRedeemable(data: $data) {
      enqueued
    }
  }
`;
